import { nonEmptyTrimmedStringFromUnknown } from "../protocol/shared.js";
import { agentProfileIdSchema, openMeldRuntimeProfileIdSchema } from "../protocol/profile.js";
import { spaceDispatchPolicySchema } from "../space-mesh/dispatch-policy.js";
import { spaceAllowedActionsSchema, spacePublicationModeSchema } from "../space-mesh/publication-policy.js";
import { resultArchivePolicySchema } from "../space-mesh/result-archive-policy.js";
import { spaceAccessModeSchema, spaceLinkJoinPolicySchema } from "./space-access-mode.js";
import { spaceOrganizationVisibilitySchema } from "./space-meta.js";
import { spaceMembersSummarySchema } from "./space-members.js";
import { spaceRouteParamsSchema } from "./space-route-params.js";
import * as z$1 from "zod/v4";
//#region src/schemas/http/space-status.ts
const isoDateTimeSchema = z$1.iso.datetime({ offset: true });
const optionalTrimmedStringSchema = z$1.preprocess((value) => {
	const normalized = String(value ?? "").trim();
	return normalized.length > 0 ? normalized : void 0;
}, z$1.string().min(1).optional());
const SPACE_STATUS_PREVIEW_MAX_UTF16_UNITS = 240;
function boundSpaceStatusPreviewText(text) {
	if (text.length <= 240) return text;
	let truncated = text.slice(0, 239).trimEnd();
	const finalCodeUnit = truncated.charCodeAt(truncated.length - 1);
	if (finalCodeUnit >= 55296 && finalCodeUnit <= 56319) truncated = truncated.slice(0, -1).trimEnd();
	return `${truncated}…`;
}
const spaceStatusLatestVisibleUpdateSchema = z$1.object({
	signalId: nonEmptyTrimmedStringFromUnknown,
	signalType: z$1.enum([
		"signal.text",
		"signal.status",
		"signal.system_notice"
	]),
	createdAt: isoDateTimeSchema,
	actorProfileId: openMeldRuntimeProfileIdSchema,
	actorName: optionalTrimmedStringSchema,
	previewText: nonEmptyTrimmedStringFromUnknown.transform(boundSpaceStatusPreviewText)
});
const spaceStatusMembersSummarySchema = spaceMembersSummarySchema.extend({
	liveHumanCount: z$1.number().int().min(0),
	liveAgentCount: z$1.number().int().min(0)
});
const getSpaceStatusInputSchema = spaceRouteParamsSchema;
const getSpaceStatusResponseSchema = z$1.object({
	spaceId: nonEmptyTrimmedStringFromUnknown,
	generatedAt: isoDateTimeSchema,
	centerAgentProfileId: agentProfileIdSchema.optional(),
	name: optionalTrimmedStringSchema,
	spacePurpose: optionalTrimmedStringSchema,
	directMessageConvertedAt: isoDateTimeSchema.optional(),
	organizationVisibility: spaceOrganizationVisibilitySchema.optional(),
	ownerUserIds: z$1.array(z$1.string().min(1)).optional(),
	allowGuests: z$1.boolean().optional(),
	accessMode: spaceAccessModeSchema,
	linkJoinPolicy: spaceLinkJoinPolicySchema.optional(),
	passwordProtected: z$1.boolean(),
	dispatchPolicy: spaceDispatchPolicySchema,
	publicationMode: spacePublicationModeSchema,
	allowedActions: spaceAllowedActionsSchema,
	resultArchivePolicy: resultArchivePolicySchema,
	entryBrief: z$1.enum(["default", "none"]),
	dispatchBrief: z$1.enum(["default", "none"]),
	members: spaceStatusMembersSummarySchema,
	latestVisibleUpdate: spaceStatusLatestVisibleUpdateSchema.optional()
});
//#endregion
export { SPACE_STATUS_PREVIEW_MAX_UTF16_UNITS, boundSpaceStatusPreviewText, getSpaceStatusInputSchema, getSpaceStatusResponseSchema, spaceStatusLatestVisibleUpdateSchema, spaceStatusMembersSummarySchema };

//# sourceMappingURL=space-status.js.map